/**
 * Se o Sapron está rodando dentro de um iframe — hoje, o Programa de Indicação
 * embutido no portal do franqueado (`/parceiros/entrada`).
 *
 * É a fonte única dessa pergunta. Dentro da moldura o app só pode carregar
 * documento sob `/parceiros/*`: o resto do host responde
 * `X-Frame-Options: SAMEORIGIN`, e o IDP também recusa ser carregado em
 * moldura. Quem decide para onde o documento navega pergunta aqui antes.
 */
export const dentroDeMoldura = (): boolean => window.self !== window.top;
